import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsConditions = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-wine-950">
      <Header />

      <div className="pt-24 pb-16 bg-cream-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-wine-600 hover:text-wine-700 mb-6 text-sm font-medium transition-colors">
            <ArrowLeft className="w-4 h-4 mr-1.5" /> Back to Home
          </Link>

          <h1 className="text-4xl font-bold text-wine-950 mb-6">Terms & Conditions</h1>

          <div className="prose max-w-none space-y-6 text-stone-600">
            <p className="text-lg">
              By accessing the <strong className="text-wine-950">Trademark Text Logo</strong> website (referred to as the "Site"), you acknowledge and accept the terms and conditions outlined herein, forming an agreement between you and info@trademarktextlogo.com (referred to as "we," "us," or "our"). This agreement also incorporates our Privacy Policy as if fully stated here. If you do not agree with these terms, please refrain from using the Site.
            </p>

            <div className="bg-wine-50 border border-wine-200 rounded-xl p-4 my-6">
              <p className="text-sm text-wine-800">
                <strong>IMPORTANT:</strong> THIS AGREEMENT INCLUDES A MANDATORY ARBITRATION CLAUSE GOVERNED BY THE FEDERAL ARBITRATION ACT, AND A WAIVER OF CLASS ACTIONS.
              </p>
            </div>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Conditions for Use of the Site</h2>
              <p>Your access to and use of the Site is contingent upon your acceptance and adherence to these terms. By using the Site, you agree that you:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Will comply with these Terms of Service</li>
                <li>Are 18 years of age or older</li>
                <li>Will not use the Site in any way that violates U.S. laws</li>
                <li>Will not copy or distribute any content from the Site without our prior written consent</li>
                <li>Will provide accurate details when registering, submitting content, or interacting with the Site</li>
                <li>Will not permit others to use the Site under your user credentials</li>
                <li>Are fully responsible for all activity under your account</li>
                <li>Will not use the Site for commercial purposes other than those expressly stated</li>
                <li>Are solely responsible for any content you submit to the Site</li>
                <li>Agree that we may remove any of your content and suspend or terminate your account</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Your Content</h2>
              <p>We reserve the right to publish any content you provide. You agree not to upload or use any content that:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Violates the intellectual property rights of others</li>
                <li>Infringes on privacy or publicity rights of any third party</li>
                <li>Is unlawful, inaccurate, defamatory, discriminatory, obscene, or harassing</li>
                <li>Encourages criminal activity or civil liability</li>
                <li>Is deemed inappropriate by us, in our sole discretion</li>
                <li>Could harm our company, affiliates, or partners</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Your Behavior</h2>
              <p>By using the Site, you agree not to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Engage in or promote illegal activities</li>
                <li>Attempt to reverse engineer or disrupt the Site's functionality</li>
                <li>Attempt to access restricted areas of the Site</li>
                <li>Use the Site for unsolicited email campaigns or spam</li>
                <li>Use automated tools to scrape or collect data from the Site</li>
                <li>Interfere with the proper functioning of the Site</li>
                <li>Impersonate another user</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Links to Third-Party Sites</h2>
              <p>Our Site may contain links to third-party websites not controlled by us. We assume no responsibility for the content or practices of these external sites.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Termination</h2>
              <p>We reserve the right to modify or discontinue the Site or any services provided without prior notice. Additionally, we may terminate this agreement for any reason, with or without notice.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Search Services</h2>
              <p>If you use our search services, we employ reasonable methods to identify potential matches to the trademarks you wish to use. However, we cannot guarantee that your trademark will be approved by the USPTO.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Trademark Search Scope</h2>
              <p>Our <strong className="text-wine-950">Trademark Text Logo</strong> searches include:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-wine-950">Federal Search:</strong> Reviews the USPTO database including direct matches, phonetic similarities, or visual design similarities</li>
                <li><strong className="text-wine-950">Federal, State, and Common Law Search:</strong> Extends to all 50 states, business registries, and domain name databases</li>
                <li><strong className="text-wine-950">Global Search:</strong> Includes USPTO, state databases, WIPO database, and European Community database</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Disclaimers of Warranty and Limitations of Liability</h2>
              <div className="bg-white p-6 rounded-xl border border-stone-200">
                <p className="text-sm uppercase font-bold mb-4 text-wine-950">IMPORTANT LEGAL NOTICE</p>
                <p className="text-sm">WE PROVIDE THE WEBSITE AND RELATED SERVICES "AS IS", "WHERE IS", AND "AS AVAILABLE." TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ANY AND ALL EXPRESS OR IMPLIED WARRANTIES.</p>
                <p className="text-sm mt-4">WE SHALL NOT BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES ARISING FROM YOUR USE OF, INABILITY TO USE, OR RELIANCE UPON THE WEBSITE IN ANY WAY.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Indemnity</h2>
              <p>You agree to defend, indemnify and hold harmless us, our officers, directors, representatives, employees and agents from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses arising from: (i) your violation of these Terms; (ii) your violation of any third party right; or (iii) any claim that your content causes damage to a third party.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Dispute Resolution & Arbitration</h2>
              <p>Any dispute shall be FINALLY and EXCLUSIVELY resolved by binding individual arbitration conducted by the American Arbitration Association ("AAA") under its Consumer Arbitration Rules.</p>
              <div className="bg-wine-50 border border-wine-200 rounded-xl p-4 my-4">
                <p className="text-sm font-bold text-wine-800">NO CLASS ACTION, OR OTHER REPRESENTATIVE ACTION OR PRIVATE ATTORNEY GENERAL ACTION OR JOINDER OR CONSOLIDATION OF ANY CLAIM WITH A CLAIM OF ANOTHER PERSON SHALL BE ALLOWABLE.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Refund Policy</h2>
              <p>All packages include attorney-conducted searches and are non-refundable. Once a search and clearance report is issued, payment will be automatically processed within 24-48 hours if we do not receive a response from you.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-wine-950 mt-8 mb-4">Contact Information</h2>
              <p>If you have any questions regarding these Terms & Conditions, please contact us at:</p>
              <div className="bg-white p-6 rounded-xl border border-stone-200 mt-4 text-stone-700">
                <p><strong className="text-wine-950">Company:</strong> Trademark Text Logo</p>
                <p><strong className="text-wine-950">Address:</strong> 18952 MacArthur Blvd Suite 100, Irvine, CA 92612, United States</p>
                <p><strong className="text-wine-950">Phone:</strong> (800) 555-1234</p>
                <p><strong className="text-wine-950">Email:</strong> info@trademarktextlogo.com</p>
              </div>
            </section>

            <p className="text-sm text-stone-400 mt-8 pt-8 border-t border-stone-200">
              <strong>Last Updated:</strong> February 1, 2026
            </p>

            <p className="mt-6">By using our website and services, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions.</p>
          </div>
        </div>
      </div>

      <Footer onOpenContactForm={() => {}} />
    </div>
  );
};

export default TermsConditions;
